export function VendorPaymentCtrl (
  $scope,
  inheritorApi,
  payment,
  vendor
) {
  $scope.payment = payment;
  $scope.vendor  = vendor || {};

  inheritorApi.inheritCtrl('VendorPaymentLiteCtrl', $scope);
}